export default "__VITE_ASSET__CpHJSgCg__"